var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right"},_vm._l((_vm.contents),function(content,index){return _c('common-classifier',{key:index,attrs:{"title":content.title,"classList":content.classList,"routePrev":content.routePrev}})}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fcc9c30","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav_poetry/PoetryRight.vue
// module id = 1487
// module chunks = 0